export default __webpack_public_path__ + "static/ios_service_features-b111b9a7d94f40d97dbc7d476bebb17e.svg";